export default __webpack_public_path__ + "static/media/penaltyIcon.f7ef4a50.png";